module.exports = __webpack_public_path__ + "static/media/why_lv.f992672f.vtt";